import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';

declare const mapUtilityMapBox;

@Component({
  selector: 'g10-rostering-guest',
  templateUrl: './rostering-guest.component.html',
  styleUrls: ['./rostering-guest.component.css']
})

export class RosteringGuestComponent implements OnInit {
  
  @Input() popup  = true;
  @Input() modalTitle  = 'Add Guest';
  @Input() selectedGuest = {};
  @Input() edit = false;
  @Input() routeData;
  @Input() ppGuestList = [];
  @Input() selectedGuestList = [];
  @Output() closeEvent = new EventEmitter();
  @Output() result = new EventEmitter();

  //Map
  public rosteringGuestMap:any;
  public showMap:boolean = false;
  public markerId = 'rosteringGuestMapId';
  public markerRadiusId = 'rosteringGuestMapRadiusId';
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];

  // form
  public guestform = {
    guest:'',
    fromDate:'',
    toDate:'',
  };

  public newGuestObj = {
    name:'',
    mobileNo:'',
    email:'',
    gender:'',
    fromDate:'',
    toDate:'',
    userType:'',
    lat:0,
    lng:0,
    location:'',
  }

  public formSubmitted:boolean = false;
  public errorObject = {};

  //time

  public showDate:boolean = true;
  public showDatePicker:boolean = false;
  public invalidDate:boolean = false;
  public minDate:any;
  public maxDate:any;
  public defaultFromDate='';
  public defaultToDate='';

  //availableGuest
  public customActiveTap = 'availableGuest';
  public guestType = 'existing';
  public guestList = [];
  public selectedGuestObj = [];
  public guestData = [];
  public tabChanged:boolean = false;
  public showGuest:boolean = true;

  constructor(
    private api:ApiService,
    private comservice:CommonServices
  ) { }

  ngOnInit(): void {
    this.getGuestList();

    this.showDate = false;
    setTimeout(()=>{ 
      if(Object.keys(this.routeData).length>0){
        let fDate = new Date(this.routeData.fromDate);
        this.minDate = fDate.getFullYear()+"-"+this.comservice.pad(fDate.getMonth()+1)+"-"+this.comservice.pad(fDate.getDate());
        if(this.routeData.toDate){
          let tDate = new Date(this.routeData.toDate);
          this.maxDate = tDate.getFullYear()+"-"+this.comservice.pad(tDate.getMonth()+1)+"-"+this.comservice.pad(tDate.getDate());          
        }
        this.showDate = true;
      }
    },500);

  }

  getGuestList(){
    this.api.transportManagerGuestList({}).then((res:any)=>{
      this.guestData = [ ...res.data];
      this.guestList = res.data.map(item => {
       return { "name": item.name, value: item.guestID,}   });
       
       // selected vehicle ignoring  
       this.selectedGuestList.filter((guest)=>{
         this.guestList.filter((e,index)=>{
           if(e.value == guest.guestID) 
            this.guestList[index] = { disabled:true,...this.guestList[index] };
         });
       })
       this.ppGuestList.filter((ppGuest)=>{
        this.guestList.filter((e,index)=>{
          if(e.value == ppGuest.guestID) 
           this.guestList[index] = { disabled:true,...this.guestList[index] };
        });
       })

       console.log(this.guestList,this.ppGuestList,this.selectedGuestList);

       if(this.edit && this.selectedGuest){
         this.selectedGuestObj = [];
         this.showDate = false;
         this.showGuest = false;
         this.guestList.filter((guest)=>{
           if(guest.value == this.selectedGuest['guestID']){
             delete guest.disabled;
             this.selectedGuestObj.push({ ...guest});
             this.defaultFromDate = this.comservice.timestampToDate(this.selectedGuest['fromDate'], 'YMD', '-');
             this.defaultToDate = this.comservice.timestampToDate(this.selectedGuest['toDate'], 'YMD', '-');
             this.guestform['guest']= this.selectedGuest['guestID'];
             this.guestform['fromDate'] = this.selectedGuest['fromDate']; 
             this.guestform['toDate'] = this.selectedGuest['toDate']; 
            }
          })
          setTimeout(()=>{ 
            console.log(this.guestList,this.selectedGuestObj);
            this.showDate = true; 
            this.showGuest = true;
          },300);
       }

       // console.log('this.vehiclelists ',this.vehiclelists,this.vehiclelists.length);
    })
  }
  getSelectedGuest(e){
    this.guestform['guest']= e.value;
    if(!this.tabChanged == this.formSubmitted) this.validation();
    console.log(this.guestform);
  }
  removeGuest(){
    this.tabChanged = true;
    this.formSubmitted = false
    delete this.guestform['guest'];
  }
  removeNewGuest(){
    this.tabChanged = true;
    this.formSubmitted = false;
    this.customActiveTap='availableGuest';
    this.guestType="existing";
      Object.keys(this.newGuestObj).forEach((item:any)=>{
            delete this.guestform[item];            
      });
  }

  addNewGuest(){
    this.customActiveTap='addNewGuest';
    this.guestType="temporary";
    this.removeGuest();
    this.initMap();
    Object.keys(this.newGuestObj).forEach((item:any)=>{
        this.guestform[item] = '';          
    });
    console.log(this.guestform);
  }

  /* Map Functionality  */

  initMap(){
    try {
        const mapBoxKey = 'pk.eyJ1Ijoib3dlbmxhbWIiLCJhIjoiY2lleWljcnF4MDBiOXQ0bHR0anRvamtucSJ9.t3YnHHqvQZ8Y0MTCNy0NNw';
        const parent = this;
        if (mapBoxKey) {
          const MyMap1 = new mapUtilityMapBox();
          MyMap1.setup('rosteringGuestMap', {
            key: mapBoxKey
          },
            function (map) {             
              parent.rosteringGuestMap = map;  
              parent.showMap = true;
              parent.rosteringGuestMap.onMapClick(($event) => parent.mapClickEventListen($event));    
            });
        }
      } catch (error) {
        console.log(error);
      }
    }

  mapClickEventListen($event) {
      console.log($event);
    // if (this.pickupFromMap === false) return
    this.vehicleMarker($event['lngLat']['lat'], +$event['lngLat']['lng']);

    this.guestLocationChanged($event['lngLat']['lat'], +$event['lngLat']['lng'])

    this.latlngDrawRadius($event['lngLat']['lat'], $event['lngLat']['lng']);


    this.rosteringGuestMap.onDrag([this.markerId], (e) => {
        // console.log(e.target._lngLat['lat']);
        this.guestLocationChanged(e.target._lngLat['lat'], e.target._lngLat['lng'])
        this.latlngDrawRadius(+e.target._lngLat['lat'], e.target._lngLat['lng']);
        // markerId
    });
  }

  vehicleMarker(lat, lng) {
    lat = +lat.toFixed(5); lng = +lng.toFixed(5);
    this.rosteringGuestMap.marker(
        {
            id: this.markerId,
            content: '<div class="mumb_marker_pin" style="background: #686ab9;"></div>',
            lat: lat,
            lng: lng,
            draggable: true   // <<<<< Important
        }
    );
    this.rosteringGuestMap.focus({
        lat: lat,
        lng: lng,
        zoom: 14
    });
}

guestLocationChanged(lat, lng) {
    this.guestform['lat'] = +lat.toFixed(5);
    this.guestform['lng'] = +lng.toFixed(5);
    this.rosteringGuestMap.geocoder(
        `${lng},${lat}`, (res) => {
            try {
                const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } });
                this.guestform['location'] = locations[0]['name'];
                if(this.formSubmitted) this.validation();
            } catch (er) { console.log(er) };
        });
  }

  latlngDrawRadius(lat, lng) {
      this.rosteringGuestMap.drawCircle({
          name: this.markerRadiusId, // unique like id
          lat: +lat.toFixed(5), lng: +lng.toFixed(5),
          km: '0.3',
          color: "rgba(255,0,0,0.2)"
      });
  }
  mapSearchFind(location) {

    clearTimeout(this.mapSearchDebounceTimeOut);
    this.mapSearchDebounceTimeOut = setTimeout(() => {
        this.rosteringGuestMap.geocoder(
            `${location}`, (res) => {
                try {
                    // console.log(res.features);
                    const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } });
                    // this.pickupPoints[this.editIndex]['location'] = locations[0]['name'];
                    this.rosteringGuestMap.focus({
                        lat: locations[0]['center'][1],
                        lng: locations[0]['center'][0],
                        zoom: 15
                    });
                    this.mapSearchDataLists = [];
                    this.mapSearchDataLists = locations;
                } catch (er) { console.log(er) };
            });

    }, 600);

}

  removeCircleAndMarker() {
      this.rosteringGuestMap.removeMarker(this.markerId);
      this.rosteringGuestMap.removeCircle(this.markerRadiusId);
  }

  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      this.guestform[type] = x.getTime();
    });
    if (this.formSubmitted) this.validation();
  }

  validation() {
    let objectKeys = Object.keys(this.guestform);
    console.log(this.guestform);
    this.errorObject = {};
    let isValid = true;
    this.errorObject['invalidDate'] = '';
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (this.guestform[key] == '' || this.guestform[key] == undefined || this.guestform[key] == null || this.guestform[key].length <= 0) {

        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        if(!this.showDate){ delete this.errorObject['fromDate']; delete this.errorObject['toDate'];}
        isValid = false;
      } 
      else if (key == 'fromDate' || key == 'toDate') {
        this.invalidDate = false;
        if ((this.guestform.toDate !='') && this.guestform.fromDate > this.guestform.toDate) {
          isValid = false;
          this.invalidDate = true;
          this.errorObject['invalidDate'] = 'To Date is Invalid.';
        }
      }
      else if( key== 'mobileNo'){
        const pattern = /^[0-9]{10}$/;
        let patternIsInvalid = this.patternCheckFn(pattern,this.guestform[key]);           
        if(patternIsInvalid){
          isValid = false;
          this.errorObject[key] = 'Mobile Number is Invalid.'
        }   
        
      }
      else if(key=='email'){
        const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let patternIsInvalid = this.patternCheckFn(pattern,this.guestform[key]);           
        if(patternIsInvalid){
          isValid = false;
          this.errorObject[key] = 'Email is Invalid.'
        }   
      }

    }
    return isValid;
  }

  patternCheckFn(pattern,value){
      let checkInValid:boolean;
      const inputChar = value;
      checkInValid = pattern.test(inputChar);
      return !checkInValid;
  }

  onSubmit(){   
    this.formSubmitted = true;
    let isValid = this.validation();
    let obj = {};  

    if(this.customActiveTap=='availableGuest'){ 
      this.guestData.filter((guest)=>{
        if(guest.guestID == this.guestform.guest) obj = { ...guest};
      });
      obj['fromDate'] = this.guestform.fromDate;
      obj['toDate'] = this.guestform.toDate;
    }else{
      obj = { ...this.guestform};
    }

    if(isValid){
      console.log(obj);
      this.result.emit(obj);
      this.closePopup();
    }      
  }

  closePopup(){
      this.closeEvent.emit(true);
   }

}
